export const APP_CONFIG = {
  ADD_NEW_CONTROLLER: true,
  SHOW_ALL_FIELDS: true,
  BETA_VERSIONS: false,
  SMART_HEATER: false,
  SWC_ENABLED: true,
  ALLOW_PRODUCTION_UNITS: false,
};

export const RECORD_TYPES = {
  ACCESS: 'access#',
  INSTALLER: 'installer',
  NOTES: 'notes',
  INFO: 'info',
  EVENT: 'event',
  CONFIG: 'config',
  DATA: 'data',
  FAULTS: 'faults',
  USER: 'user#',
};

export const apiLimit = 1000;
